import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectLocationName,
  selectMinMaxPrice,
  selectPrices,
  selectResults,
  selectSearchParams,
} from '../selectors/search.selectors';
import { Params } from '@angular/router';
import { updateSearchQueryParams } from '../actions/shared-search.actions';

@Injectable({ providedIn: 'root' })
export class SharedSearchFacade {
  store = inject(Store);

  searchQueryParams$ = this.store.select(selectSearchParams);
  selectMinMaxPrice$ = this.store.select(selectMinMaxPrice);
  selectPrices$ = this.store.select(selectPrices);
  selectResults$ = this.store.select(selectResults);
  longLocationName$ = this.store.select(selectLocationName);

  updateSearchQueryParams(params: Params): void {
    this.store.dispatch(updateSearchQueryParams({ params }));
  }
}
